// extracted by mini-css-extract-plugin
export var $animation_name = "MenuFooter-module--$animation_name--a9402";
export var MenuFooter = "MenuFooter-module--MenuFooter--e53d3";
export var MenuFooter__blurb = "MenuFooter-module--MenuFooter__blurb--69e17";
export var MenuFooter__logos = "MenuFooter-module--MenuFooter__logos--a16ed";
export var MenuFooter__logos___madeForThis = "MenuFooter-module--MenuFooter__logos___madeForThis--480ea";